import { useQuery, gql } from '@apollo/client';
import { useMemo } from 'react';

export const useRefferalUserState = () => {
    const { data } = useQuery(gql`
            query USER_INVITE_FRIEND_POPUP_DATA {
                user {
                    id
                    successDeliveriesCount
                    referralProgram {
                        referrals_count
                    }
                }
            }
        `,
    {
        fetchPolicy: 'cache-first',
    });

    const canShareReferralLink = useMemo(() => {
        const deliveriesCount = data?.user?.successDeliveriesCount >= 5;
        const fiendsCount = data?.user?.referralProgram?.referrals_count === 0;
        return deliveriesCount && fiendsCount;
    }, [
        data?.user?.successDeliveriesCount,
        data?.user?.referralProgram?.referrals_count,
    ]);

    return { canShareReferralLink, user_ID: data?.user?.id };
};

